import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

import { routes } from "@/routes";
import { Root } from "@/root";
import { ScrollRestoration } from "@/components/core/scroll-restoration";

const root = createRoot(document.querySelector("#root"));

// Shown while lazy routes resolve on an initial (deep-link) load. Without this,
// react-router renders nothing during that window — a blank page — and warns
// "No HydrateFallback element provided to render during initial hydration".
function HydrateFallback() {
	return (
		<div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
			<CircularProgress />
		</div>
	);
}

const router = createBrowserRouter([
	{
		path: "/",
		element: (
			<Root>
				<ScrollRestoration />
				<Outlet />
			</Root>
		),
		HydrateFallback: HydrateFallback,
		children: [...routes],
	},
]);

root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
